import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AttractionsService } from "../../services/attractions.service";
import AppConstants from "../../constants/AppConstants";

@Component({
  selector: "app-attractions",
  templateUrl: "./attractions.component.html",
  styleUrls: ["./attractions.component.scss"],
})
export class AttractionsComponent implements OnInit {
  attractions = [];
  searchQuery = "";
  count: number;
  readonly DEFAULT_PAGE_SIZE = AppConstants.DEFAULT_PAGE_SIZE;
  readonly DEFAULT_PAGE_SIZE_OPTIONS = AppConstants.DEFAULT_PAGE_SIZE_OPTIONS;
  readonly DEFAULT_PAGINATION_INFO = { pageIndex: 0, pageSize: 10 };
  pageIndex = 0;
  pageCursors: any[] = [];
  currentPageSize = 10;

  constructor(
    private attractionsService: AttractionsService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.fetchList(this.DEFAULT_PAGINATION_INFO);
  }

  pageChanged({ pageIndex, pageSize }) {
    if (this.currentPageSize !== pageSize) {
      this.currentPageSize = pageSize;
      this.pageCursors = [];
      pageIndex = 0;
    }
    this.fetchList(
      {
        pageIndex,
        pageSize,
      },
      this.searchQuery,
    );
  }

  search(input) {
    this.pageIndex = 0;
    this.pageCursors = [];
    this.fetchList({ pageIndex: 0, pageSize: this.currentPageSize }, input);
  }

  private fetchList(pageInfo, searchParam?: string) {
    this.pageIndex = pageInfo.pageIndex;
    
    // Determine the cursor to use for the requested page.
    // For page 0, we don't need a cursor (undefined).
    // For page N, we need the endCursor of page N-1.
    const cursorForPage = this.pageIndex > 0 ? this.pageCursors[this.pageIndex - 1] : undefined;

    const obj = {
      paginationData: {
        pageIndex: pageInfo.pageIndex,
        pageSize: pageInfo.pageSize,
        after: cursorForPage,
      },
      searchParam: searchParam,
    };

    this.attractionsService.getAllAttractions(obj).subscribe((result) => {
      if (result && result.data) {
        const attractionsData = result.data["attractions"];
        this.attractions = attractionsData.edges.map((edge) => edge.node); // Extract node data from edges
        this.count = attractionsData.totalCount; // Use totalCount for the paginator
        
        // Save the cursor for the current page so we can use it to fetch the next page
        this.pageCursors[this.pageIndex] = attractionsData.pageInfo;
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/attractions/attractions.component.ts